import { Component, OnInit, Input } from '@angular/core';
import { Property } from '../models/property';
import { CommonModule } from '@angular/common';

import { ApiService } from '../services/api.service';
import { ModalController} from '@ionic/angular';

import { PropertyAddComponent } from '../property-add/property-add.component';
//import { PropertySearchPipe } from '../pipes/propertySearchFilter.pipe';

@Component({
  selector: 'app-property-chooser',
  templateUrl: './property-chooser.component.html',
  styleUrls: ['./property-chooser.component.scss'],
  //providers: [ PropertySearchPipe ]
})
export class PropertyChooserComponent implements OnInit {

  @Input() public contactId: number;
  properties: Property[];
  filterTerm: string;

  constructor(public apiService: ApiService, public modalCtrl: ModalController) { }

  ngOnInit() {}

  ionViewWillEnter() {
    // Used ionViewWillEnter as ngOnInit is not 
    // called due to view persistence in Ionic
    this.getAllProperties(this.contactId);
  }

  getAllProperties(contactId) {

    // Get contact properties
    this.apiService.getPropertyListByContact(contactId).subscribe(response => {
      this.properties = response;
      console.log(this.properties);
    });

  }

  dismiss() {  
    return this.modalCtrl.dismiss();
  }

  chooseProperty(property) {
    return this.modalCtrl.dismiss(property, 'confirm');
  }

  handleSearch(event) {
    const query = event.target.value.toLowerCase();
    this.apiService.getPropertyListByContactFiltered(this.contactId, query).subscribe(response => {
      this.properties = response;
    })
  }

  async showNewPropertyModal() {  
    const modal = await this.modalCtrl.create({  
      component: PropertyAddComponent,
      componentProps: { contactId: this.contactId },
    });

    modal.onDidDismiss()
      .then((data) => {

        const property = data.data;

        if (property != null){
          // TODO: Toast notification
          //this.presentToast('A new Contact was created.');

          // Refresh data
          this.getAllProperties(this.contactId);
        }
        else {
          // User has dismissed creating a new contact without saving
        }
    });

    await modal.present();
  }

}
